import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import ym from "react-yandex-metrika";

export function XsollaReturn() {
  const location = useLocation();
  const history = useHistory();
  const [status, setStatus] = useState("processing");

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const xsollaStatus = query.get("status");

    // Xsolla retorna ?status=done em pagamentos bem-sucedidos
    if (xsollaStatus === "done") {
      sessionStorage.removeItem("xsollaOrderId");
      ym("reachGoal", "purchase_completed");
      setStatus("success");
      setTimeout(() => history.push("/"), 3000);
    } else {
      // Cancelamento ou retorno sem status — apenas redireciona
      sessionStorage.removeItem("xsollaOrderId");
      setStatus("cancelled");
      setTimeout(() => history.push("/"), 3000);
    }
  }, [location.search, history]);

  return (
    <div style={wrapper}>
      {status === "processing" && <ProgressSpinner />}
      {status === "success" && (
        <div style={message}>Payment confirmed. Redirecting…</div>
      )}
      {status === "cancelled" && (
        <div style={message}>Payment was not completed. Redirecting…</div>
      )}
    </div>
  );
}

const wrapper = {
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "1rem",
};

const message = {
  color: "#fff",
  fontSize: "1.1rem",
};

export default XsollaReturn;
